<!--
	@name app-common-flood-report
	@description Generate a flood report from a postcode
	@date 2020/03/01
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<v-btn :small="buttonSize == 'small'" :large="buttonSize == 'large'" color="blue darken-1" :loading="loading" @click="openFloodRiskReportOptions">
			<v-icon left>
				mdi-weather-pouring
			</v-icon>
			Download Flood Report PDF
		</v-btn>
		<flood-risk-report-dialog ref="floodRiskReportDialog" :loading="loading" @openFloodReport="openFloodRiskReport" />
	</div>
</template>

<script>
	import FloodRiskReportDialog from '@/component/common/dialog/flood-risk-report';
	import { ElementTools, GoogleAnalytics, PopupWindow } from '@/utils';
	import { mapActions } from 'vuex';

	export default {
		name: 'app-common-flood-report',

		components: {
			FloodRiskReportDialog
		},

		props: {
			buttonSize: { type: String, required: false, default: 'small' },
			newChip: { type: Boolean, required: false, default: true },
			postcode: { type: String, required: true }
		},

		data() {
			return {
				loading: null
			};
		},

		methods: {
			...mapActions('AppCalculator', ['generateFloodReport']),

			async initGenerateFloodReport(params) {
				this.loading = true;
				ElementTools.fireNotification(this.$el, 'info', { text: 'Your flood report PDF is being prepared', timeout: 0 });

				this.generateFloodReport(params)
					.then((response) => {
						let newWin = new PopupWindow().open(response.data);
						if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
							ElementTools.fireNotification(
								this.$el,
								'warning',
								`Your flood report PDF is now ready; however, your browser has prevented the document from being downloaded automatically.. <a href="${response.url}" target="_blank" class="white--text text-decoration-underline">Click here</a> to proceed.`
							);
						} else ElementTools.fireNotification(this.$el, 'success', 'Your flood report PDF has been downloaded');
					})
					.catch(() =>
						ElementTools.fireNotification(this.$el, 'error', {
							text: 'An unexpected error occurred whilst generating your flood report. Please check that the postcode is correct, as an invalid postcode will result in a failed response. If this problem continues, please contact our support team',
							timeout: 0,
							close: true
						})
					)
					.finally(() => (this.loading = false));
			},

			openFloodRiskReportOptions() {
				this.$refs['floodRiskReportDialog'].floodRiskReportBox = true;
			},

			openFloodRiskReport(type) {
				GoogleAnalytics.floodReportChecked({ option: type === 1 ? 'Long Term Flood Risk Report' : 'Flood Map for Planning Report' });
				if(type === 1) {
					window.open('http://check-long-term-flood-risk.service.gov.uk/', '_blank');
				} else {
					window.open('https://flood-map-for-planning.service.gov.uk/location', '_blank');
                    //this.initGenerateFloodReport({ postcode: this.postcode });
				}
			}
		}
	};
</script>
